import React, { FC } from 'react';
import { ActionsButtonProps } from './colorSwatchModalInterface';
import { ActionButtonContainer, ActionButtonStyled } from './styled';

const ActionsButton: FC<ActionsButtonProps> = ({
    handleClickCancel,
    handleClickConfirm,
    labelCancel,
    labelConfirm,
    buttonConfirmDisabled,
}) => (
    <ActionButtonContainer>
        <ActionButtonStyled
            lighten={1}
            onClick={handleClickCancel}
            variant="text"
            disableRipple
        >
            {labelCancel}
        </ActionButtonStyled>
        <ActionButtonStyled
            disabled={buttonConfirmDisabled}
            onClick={handleClickConfirm}
            variant="text"
            default
            disableRipple
        >
            {labelConfirm}
        </ActionButtonStyled>
    </ActionButtonContainer>
);

export default ActionsButton;
